import React from 'react'
import Chip from '@material-ui/core/Chip'
import { withStyles } from '@material-ui/core/styles'
import CancelIcon from 'design-framework/common/icons/cancel-icon.svg'
import CloseIcon from 'design-framework/common/icons/close-i.svg'
import Icon from 'design-framework/common/ui/Icon'
import { ChipWrapper, TextPlaceholder, CancelIconDiv } from './__style'

const Chips = ({
	handleClick,
	handleDeletion,
	big,
	text,
	chipStyles,
	labelStyles,
	iconStyles,
}) => {
	const CustomisedChip = withStyles({
		root: {
			background: '#3E6EEA',
			color: 'white',
			borderRadius: '4px',
			'&:hover': {
				background: '#3E6EEA',
			},
			'&:focus': {
				background: '#3E6EEA',
			},
			height: '26px',
			...chipStyles,
		},
		deleteIcon: {
			color: 'white',
			'&:hover': {
				color: 'white',
			},
			'&:focus': {
				color: 'white',
			},
			...iconStyles,
		},
		label: {
			maxWidth: '201px',
			...labelStyles,
		},
	})(Chip)

	return big ? (
		<ChipWrapper onClick={handleClick}>
			<TextPlaceholder>{text}</TextPlaceholder>
			<CancelIconDiv>
				<Icon
					glyph={CancelIcon}
					onClick={handleDeletion}
					passThrough={['onClick']}
				/>
			</CancelIconDiv>
		</ChipWrapper>
	) : (
		<CustomisedChip
			label={text}
			onDelete={handleDeletion}
			onClick={handleClick}
			deleteIcon={
				<Icon
					glyph={CloseIcon}
					passThrough={['onClick']}
					style={{ width: '10px', height: '10px' }}
				/>
			}
		/>
	)
}

export default Chips
